
  import { underscore } from 'inflected';

  export default {
    props: {
      addressKey: { type: String, default: 'default' },
      allowManualInput: { type: Boolean, default: true },
      blankLabel: { type: Boolean, default: false },
      checkboxes: { type: Object, default () { return {}; } },
      constraints: { type: Object, default () { return {}; } },
      disabled: { type: Boolean, default: false },
      disableEdit: { type: Boolean, default: false },
      errorKey: { type: String, default: null },
      field: { type: String, required: true },
      fieldType: { type: String, default: 'text' },
      i18nAttrs: { type: Object, default () { return { q: 'order' }; } },
      i18nField: { type: String, default: null },
      i18nModel: { type: String, default: null },
      inlineLabel: { type: String, default: null },
      inputAttrs: { type: Object, default () { return {}; } },
      modelName: { type: String, required: true },
      labelText: { type: String, default: null },
      radioOptions: { type: Array, default: null },
      rangeMaxValue: { type: Number, default: 0 },
      rangeMoney: { type: Boolean, required: false },
      required: { type: Boolean, default: false },
      searchParams: { type: Object, default: null },
      searchPath: { type: String, default: null },
      showLabel: { type: Boolean, default: true },
      pillInput: { type: Boolean, default: false }
    },
    data () {
      return {
        tooltipContainer: null,
        isOpen: false
      };
    },
    computed: {
      accordion () {
        const key = `${this.i18nScope}.accordion`;
        if (this.$te(key)) {
          return this.$t(key);
        }
        return null;
      },
      calculatedConstraints () {
        if (this.fieldType === 'text' || this.fieldType === 'email') {
          return {};
        }
        return { ...this.constraints, ...{ min: this.minValue, max: this.maxValue, step: this.calculatedStep } };
      },
      calculatedStep () {
        return this.inputAttrs.step || this.validations.step || this.constraints.step || 1;
      },
      errorMessage () {
        const errors = this.$store.getters['utils/getFormErrors'];

        if (Object.keys(errors).length <= 0) {
          return null;
        }

        if (this.errorKey && errors[this.errorKey]) {
          return errors[this.errorKey];
        }
        if (errors[this.field]) {
          return errors[this.field];
        }
        return errors[[this.modelName, this.field].join('.')] || errors[[underscore(this.modelName), this.field].join('.')];
      },
      i18nScope () {
        return `${this.i18nModel || this.modelName}.${this.i18nField || this.field}`;
      },
      maxValue () {
        if (this.rangeMaxValue > 0) {
          return this.rangeMaxValue;
        }
        const maxes = [this.constraints.max, this.validationFor('less_than_or_equal_to')];
        const lt = this.validationFor('less_than');
        if (lt) {
          maxes.push(lt - this.calculatedStep);
        }
        return Math.min(...maxes.filter(v => v));
      },
      minValue () {
        if (this.inputAttrs.min) {
          return this.inputAttrs.min;
        }
        const values = [this.constraints.min, this.validationFor('greater_than_or_equal_to'), this.validationFor('at_least')].filter(v => !isNaN(v));
        if (values.length) {
          return Math.max(...values);
        }
        return 0;
      },
      placeholder () {
        const key = `${this.i18nScope}.placeholder`;
        return this.$te(key) ? this.$t(key) : null;
      },
      subtitle () {
        const key = `${this.i18nScope}.subtitle`;
        if (this.$te(key)) {
          return this.$t(key);
        }
        return null;
      },
      showError () {
        return this.$slots.customErrorMessage || this.errorMessage || false;
      },
      tooltipOptions (e) {
        const key = `${this.i18nScope}.tooltip`;
        if (this.$te(key)) {
          let opts = { classes: 'fieldsetTooltip', content: this.$t(key), container: this.tooltipContainer, placement: 'top' };
          if (!this.$store.getters['utils/isTablet']) {
            opts.trigger = 'click';
          }
          return opts;
        }
        return null;
      },
      validations () {
        return [ ...this.$store.getters['products/getValidations'] ].filter(v => v.field === this.field).map(v => v.options);
      }
    },
    watch: {
      errorMessage (newVal) {
        if (newVal && !this.$store.getters['utils/getFormErrorScrolled']) {
          this.$store.commit('utils/setFormErrorScrolled', true);
          this.$el.scrollIntoView(
            {behavior: 'smooth'}
          );
        }
      }
    },
    mounted () {
      this.tooltipContainer = this.getToolTipSpan();
    },
    methods: {
      getToolTipSpan () {
        return this.$refs['tooltip'];
      },
      validationFor (operation) {
        const validation = this.validations.find(v => v[operation]);
        return validation ? validation[operation] : null;
      },
      toggleAccordion () {
        this.isOpen = !this.isOpen;
      }
    }
  };
